import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./CN.css";
import "./CNmedia.css"
import CarouselControls from "../CarouselControls/CarouselControls";

import corporativa from "./corporativa.png";
import porque from "./porque.png";
import equipo from "./corporativa.png";
import etica from "./etica.png";
import vision from "./vision.png";
import mision from "./mision.png";

const slidesData = [
  {
    id: 0,
    backgroundImage: equipo,
    subtitle: "¿Quiénes Somos?",
    title: "Equipo",
    description: "Somos “una gran familia” en la que combinamos nuestras experiencias de trabajo y técnicas que están a la vanguardia para la realización de nuestros proyectos. Nuestro equipo de trabajo se compone por profesionales altamente motivados al crecimiento profesional con constante capacitación para la solución de los retos de cada proyecto.",
    buttonText: "Ver proyectos residenciales"
  },
  {
    id: 1,
    backgroundImage: mision,
    subtitle: "¿Quiénes Somos?",
    title: "Misión",
    description: "La Misión de CNgroup es desarrollar soluciones energéticas sostenibles, eficaces y viables, fruto de la investigación de nuevas y diferentes formas de producción de energía, de manera sostenible para el medio ambiente y rentable para los inversores.",
    buttonText: "Explora nuestros diseños"
  },
  {
    id: 2,
    backgroundImage: vision,
    subtitle: "¿Quiénes Somos?",
    title: "Visión",
    description: "La Visión de CNgroup consiste en alcanzar la excelencia y convertirse en un referente mundial en el desarrollo y gestión de proyectos energéticos sostenibles. Persigue la excelencia a todos los niveles: trabaja por la innovación, calidad y rentabilidad, para que el día de mañana sus clientes obtengan vanguardia, eficiencia y beneficios.",
  },
  {
    id: 3,
    backgroundImage: etica,
    subtitle: "¿Quiénes Somos?",
    title: "Valores: Ética",
    description: "En CNGroup nos guían principios fundamentales como la innovación constante, la investigación rigurosa, el compromiso con la sostenibilidad, la superación permanente y la integridad en todas nuestras acciones. Estos pilares definen nuestra cultura organizacional y nuestro enfoque hacia el desarrollo energético sostenible.",

  },
  {
    id: 4,
    backgroundImage: corporativa,
    subtitle: "¿Quiénes Somos?",
    title: "R.S. Corporativa",
    description: "La estrategia de CNGroup se sustenta en tres fundamentos clave: inversión sostenida en I+D+i para la innovación tecnológica, una política de responsabilidad social que fomenta el desarrollo económico armónico y compartido, y un compromiso ambiental que promueve el uso racional de los recursos naturales en todas nuestras operaciones.",

  },
  {
    id: 5,
    backgroundImage: porque,
    subtitle: "¿Quiénes Somos?",
    title: "¿Por qué CNGroup?",
    description: [
      "CNgroup aplica su estrategia empresarial más allá del cumplimiento de las obligaciones jurídicas, fiscales o laborales; invirtiendo más en capital humano, en el entorno y en las relaciones con sus grupos de interés.",
      "CNgroup es una empresa sostenible, que crea valor económico, ambiental y social, a corto y largo plazo, contribuyendo al aumento del bienestar y al auténtico progreso de las generaciones presentes y futuras.",
      "CNgroup se basa en la Mejora Continua Empresarial; constituyéndose como herramienta y metodología fundamental para conseguir la mejora continua tanto en la productividad y rendimientos de la empresa como en la calidad de vida de sus integrantes."
    ]
  }
];

const CNgroup = () => {
  const { slideIndex } = useParams();
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = slidesData.length;
  const currentData = slidesData[currentSlide];

  useEffect(() => {
    if (slideIndex !== undefined) {
      const index = parseInt(slideIndex);
      if (!isNaN(index) && index >= 0 && index < totalSlides) {
        setCurrentSlide(index);
        window.scrollTo(0, 0);
      }
    }
  }, [slideIndex, totalSlides]);

  const nextSlide = () => {
    const newIndex = currentSlide === totalSlides - 1 ? 0 : currentSlide + 1;
    setCurrentSlide(newIndex);
  };

  const prevSlide = () => {
    const newIndex = currentSlide === 0 ? totalSlides - 1 : currentSlide - 1;
    setCurrentSlide(newIndex);
  };

  const goToSlide = (index) => {
    if (index >= 0 && index < totalSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div className="cngroup-page">
      {/* Agrega estos contenedores como en tu versión antigua */}
      <div
        className="background-container-cngroup"
        style={{ backgroundImage: `url(${currentData.backgroundImage})` }}
      ></div>
      <div className="overlay-dark"></div>

      <Navbar />
      {/* Contenedor principal del carrusel */}
      <div className="carousel-container">
        {/* Contenido (textos) */}
        <div className="carousel-content">
          <div className="container-wrapper">
            <div className="text-content">
              <p className="cngroup-subtitle">{currentData.subtitle}</p>
              <h1 className="cngroup-title">{currentData.title}</h1>
              <div className="cngroup-description">
                {Array.isArray(currentData.description) ? (
                  currentData.description.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))
                ) : (
                  <p>{currentData.description}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Usa el componente CarouselControls aquí */}
        <CarouselControls
          totalSlides={totalSlides}
          currentSlide={currentSlide}
          onNext={nextSlide}
          onPrev={prevSlide}
          onDotClick={goToSlide}
          variant="bar"
          position="absolute"
          className="cngroup-carousel-controls"
        />
      </div>

      <Footer />
    </div>
  );
};

export default CNgroup;